export function formatCellValue(value: any) {
  if (value === null || value === undefined || value === '') return '—'
  if (typeof value === 'string') return value
  if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint') {
    return String(value)
  }

  try {
    const serializedValue = JSON.stringify(value, null, 2)
    return serializedValue === undefined ? String(value) : serializedValue
  } catch {
    return String(value)
  }
}
